export const formatMsisdn = (value: string, length: 10 | 12 = 12): string => {
  if (!value) return value;

  // Normalizar: solo números
  let msisdn = value.replace(/\D/g, '');

  // Caso: queremos 12 dígitos (57 + número)
  if (length === 12) {
    if (msisdn.length === 10) {
      return `57${msisdn}`;
    }

    if (msisdn.length === 12 && msisdn.startsWith('57')) {
      return msisdn;
    }

    // fallback: no tocar
    return msisdn;
  }

  // Caso: queremos 10 dígitos (sin 57)
  if (length === 10) {
    if (msisdn.length === 12 && msisdn.startsWith('57')) {
      return msisdn.slice(2);
    }

    if (msisdn.length === 10) {
      return msisdn;
    }

    // fallback
    return msisdn;
  }

  return msisdn;
};
